import SearchTurmas from './SearchTurmas';

export default SearchTurmas;